module.exports = __webpack_public_path__ + "img/karnet.9ff058f6.png";